// tslint:disable

import * as moment from 'moment';
import * as React from 'react';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { ValidatorComponent } from '../libs/validator.component';
import { Validator } from '../libs/Validators';
import './datepicker.scss';

(moment as any).suppressDeprecationWarnings = true;

// https://github.com/YouCanBookMe/react-datetime

export interface DatepickerFieldPropInterface {
    className?: string;
    title?: string;
    defaultValue?: any;
    property?: string;
    field: Field;
    dateFormat?: string;
    timeFormat?: string | boolean;
    validators?: Validator[];
    disabled?: boolean;
    onChange?: (value: any) => void;
}

/**
 * @Learn about this component
 * https://github.com/YouCanBookMe/react-datetime
 */

export class DatepickerField extends BaseField<DatepickerFieldPropInterface> {
    public static DATE_FORMAT = 'DD-MM-YYYY';
    public static TIME_FORMAT = 'HH:mm:ss';
    public field: Field = this.props.field;
    public state = {
        defaultValue: undefined,
        disabled: this.field.disabled
    };

    componentWillMount() {


        this.setState({
            defaultValue: (typeof this.props.defaultValue !== 'undefined') ? moment(this.props.defaultValue ? this.props.defaultValue() : Date()).format(DatepickerField.DATE_FORMAT + ' ' + DatepickerField.TIME_FORMAT) : undefined
        });

        if (typeof this.props.defaultValue !== 'undefined') {
            this.field.setValue(this.parseOutputFormat(this.state.defaultValue), true, false);
            this.field.onValidate$.next();
        }


    }

    componentDidMount() {
        this.field.registerField();

        if (this.props.defaultValue) {
            this.onValueChange(this.parseValue(this.props.defaultValue));
        }

        this.field.onValueChanges$.subscribe((value) => {
            this.setState({
                defaultValue: this.parseValue(value)
            });
            this.field.setValue(this.parseOutputFormat(value), true, false);
            if (this.props.onChange) {
                this.props.onChange(this.parseOutputFormat(value));
            }
        });

        if (this.props.validators) {
            this.props.validators.forEach((v: Validator) => this.field.addValidator(v));
        }

        if (this.field.value && this.field.registered) {
            this.onValueChange(this.field.value);
        }

        if (typeof this.props.disabled !== 'undefined') {
            this.field.disabled = this.props.disabled;
            this.setState({disabled: this.field.disabled});
        }

        this.field.onDisableChanges$.subscribe((value: boolean) => {
            this.setState({disabled: value});
            this.field.disabled = value;
        });

    }

    public onValueChange(event: any) {
        if (!this.state.disabled) {
            this.field.setValue(this.parseOutputFormat(event), false, false);
            this.setState({
                defaultValue: this.parseValue(event)
            });
            this.field.onValidate$.next();
        }
    }

    render() {
        return (
            <div className={this.props.className} id={this.uid}>
                <div className={'form-group custom-datepicker-field-wrapper'}>
                    <label htmlFor={this.uid + '_input'}>{this.props.title || this.field.title}</label>
                    <div className="input-group input-prepend">
                        <span className='add-on input-group-addon' style={{minWidth: 30}}>
                            <i className='glyph-icon fa-calendar'/>
                        </span>

                        {this.state.disabled &&
                        <input className="form-control" readOnly={true} value={this.state.defaultValue}/>}

                        {!this.state.disabled && <Datetime
                            dateFormat={this.props.dateFormat || DatepickerField.DATE_FORMAT}
                            timeFormat={this.props.timeFormat || DatepickerField.TIME_FORMAT}
                            locale="en-gb"
                            inputProps={{
                                readOnly: true
                            }}
                            closeOnSelect={true}
                            onChange={(event: any) => this.onValueChange(event)}
                            value={this.state.defaultValue}
                        />}

                        <ValidatorComponent field={this.field}/>
                    </div>
                </div>
            </div>
        );
    }

    private parseValue(v: any) {
        return moment(v).format((this.props.dateFormat || DatepickerField.DATE_FORMAT) + ' ' + (this.props.timeFormat || DatepickerField.TIME_FORMAT));
    }

    private parseOutputFormat(v: any) {
        return moment(v).toISOString();
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/datepicker.field.tsx